import { useState } from "react";
import "./NavigatePages.scss";

const NavigatePages = (props) => {
  const { pageNumber, setPageNumber, isHiddenNavigationPage } = props;

  return (
    <div
      className={`navigatePagesSection ${isHiddenNavigationPage ? "none" : ""}`}
    >
      <div className="navigatePagesBox">
        <button
          className="navigatePrev round"
          onClick={() => {
            if (pageNumber > 1) {
              setPageNumber(pageNumber - 1);
            }
          }}
        >
          {"<"}
        </button>
        <span className="pageNumber">{pageNumber + ""}</span>
        <button
          className="navigateNext round"
          onClick={() => {
            if (pageNumber < 500) {
              setPageNumber(pageNumber + 1);
            }
          }}
        >
          {">"}
        </button>
      </div>
    </div>
  );
};

export default NavigatePages;
